const endpoints = {
  createMailingRules: (): string => `mailing-rule`,
  updateMailingRules: (id: string): string => `mailing-rule/${id}`,
  showMailingRule: (id: string): string => `mailing-rule/${id}`,
  inactivateMailingRule: (id: string): string =>
    `mailing-rule/inactivate/${id}`,
};

export default endpoints;
